export const dataTypes = [
  { id: 'Boolean', name: 'Boolean' },
  { id: 'Choice', name: 'Choice' },
  { id: 'DateTime', name: 'DateTime' },
  { id: 'Invalid', name: 'Invalid' },
  { id: 'Lookup', name: 'Lookup' },
  { id: 'Note', name: 'Note' },
  { id: 'Number', name: 'Number' },
  { id: 'String', name: 'String' },
  { id: 'Text', name: 'Text' }
];
